import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageFileInputTypeComponent } from './image-file-input-type.component';
import { FormlyModule } from '@ngx-formly/core';
import {
  AvatarModule,
  ButtonModule,
  FileDragAndDropModule,
  ImageComponent,
  LinkDirective,
} from '@lockton-apps/shared/ui/lui';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [ImageFileInputTypeComponent],
  imports: [
    CommonModule,
    FileDragAndDropModule,
    ReactiveFormsModule,
    MatIconModule,
    AvatarModule,
    LinkDirective,
    ImageComponent,
    ButtonModule,
    MaterialModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'image-file-input',
          component: ImageFileInputTypeComponent,
          wrappers: ['addons'],
          defaultOptions: {
            props: {
              tooltip: {
                text: $localize`Accepted formats: WORD, EXCEL, CSV, JPEG, PNG, PDF, POWERPOINT, MSG`,
              },
              accept: [
                {
                  name: 'WORD',
                  extensions: [
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  ],
                },
                {
                  name: 'EXCEL',
                  extensions: [
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  ],
                },
                {
                  name: 'CSV',
                  extensions: ['application/csv'],
                },
                {
                  name: 'JPEG',
                  extensions: ['image/jpeg'],
                },
                {
                  name: 'PNG',
                  extensions: ['image/png'],
                },
                {
                  name: 'PDF',
                  extensions: ['application/pdf'],
                },
                {
                  name: 'POWERPOINT',
                  extensions: [
                    'application/vnd.ms-powerpoint',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                  ],
                },
                {
                  name: 'MSG',
                  extensions: ['application/vnd.ms-outlook'],
                },
              ],
            },
          },
        },
      ],
    }),
  ],
})
export class ImageFileInputModule {}
